export const categoriesSeed = [
  {
    id: "cat-tea",
    name: "Tea",
    handle: "tea",
    description: null,
    image_url: "/assets/images/categories/premium_icon.webp",
    sort_order: 1,
  },
  // {
  //   id: "cat-gift",
  //   name: "Gift Selection",
  //   handle: "gift-selection",
  //   description: null,
  //   image_url: "/assets/images/gift-selection/gift-selection-universal-placeholder.svg",
  //   sort_order: 2,
  // },
  // {
  //   id: "cat-kits",
  //   name: "Sample Kits",
  //   handle: "sample-kits",
  //   description: null,
  //   image_url: "/assets/images/sample-kits/sample-kit-universal-placeholder.svg",
  //   sort_order: 3,
  // },
  // {
  //   id: "cat-teaware",
  //   name: "Tea Ware",
  //   handle: "tea-ware",
  //   description: null,
  //   image_url: "/assets/images/teaware/A19-1-1.webp",
  //   sort_order: 4,
  // },
];

const rawProducts = [
  {
    origin: "",
    cultivation: "Organic",
    category: "Ceremonial",
    tea_type: "Matcha",
    name: "Organic Matcha C-1",
    p2025: null,
    p2026: "55,200",
    notes: "2026 harvest",
    raw_details:
      "USDA Organic | JAS Organic | Kosher(KF) | Leaf Type: First Flush Only, Okumidori (Single Cultivar)",
    tasting_color: 5,
    tasting_umami: 4.5,
    tasting_astringency: 0.5,
    color: "Dark Green",
  },
  {
    origin: "",
    cultivation: "Organic",
    category: "Ceremonial",
    tea_type: "Matcha",
    name: "Organic Matcha C-2",
    p2025: null,
    p2026: "34,800",
    notes: "2026 harvest",
    raw_details: "USDA Organic | JAS Organic | Kosher(KF) | Leaf Type: First Flush Only",
    tasting_color: 4.5,
    tasting_umami: 4,
    tasting_astringency: 1.5,
    color: "Dark Green",
  },
  {
    origin: "",
    cultivation: "Organic",
    category: "Premium",
    tea_type: "Matcha",
    name: "Organic Matcha P-1",
    p2025: null,
    p2026: null,
    notes: "2026 harvest price available from early August",
    raw_details: "USDA Organic | JAS Organic | Kosher(KF) | Leaf Type: First + Second Flush",
    tasting_color: 3.5,
    tasting_umami: 3,
    tasting_astringency: 2.5,
    color: "Green",
  },
  {
    origin: "",
    cultivation: "Organic",
    category: "Premium",
    tea_type: "Matcha",
    name: "Organic Matcha P-2",
    p2025: "10,320",
    p2026: null,
    notes: "2025 HARVEST",
    raw_details:
      "JAS Organic | Leaf Type: 1st, 2nd + Autumn Flush | Packaging: 1kg Net Weight, 10 Units/Carton",
    description:
      "High quality certified organic premium matcha. Offers an exceptionally well-rounded combination of classic green tea briskness and deep, clean base notes.",
    tasting_color: 3,
    tasting_umami: 2,
    tasting_astringency: 4,
    color: "Green",
  },

  {
    origin: "Shizuoka",
    cultivation: "Conventional",
    category: "Ceremonial",
    tea_type: "Matcha",
    name: "Shizuoka Matcha C",
    p2025: null,
    p2026: "25,200",
    notes: "2026 harvest",
    raw_details:
      "Kosher(KF) | Leaf Type: First Flush Only (Single Cultivar: Saemidori) | Packaging: 1kg Net Weight, 10 Units/Carton",
    description:
      "Premium ceremonial grade utilizing 100% Saemidori cultivar leaves from Shizuoka. Celebrated for an incredibly vibrant color profile and an intensely rich umami finish with minimal bitterness.",
    tasting_color: 5,
    tasting_umami: 4.5,
    tasting_astringency: 1,
    color: "Dark Green",
  },
  {
    origin: "Shizuoka",
    cultivation: "Conventional",
    category: "Ceremonial",
    tea_type: "Matcha",
    name: "Shizuoka Matcha S",
    p2025: null,
    p2026: "21,000",
    notes: "2026 harvest",
    raw_details: "Kosher(KF) | Leaf Type: First Flush Only",
    tasting_color: 4.5,
    tasting_umami: 4,
    tasting_astringency: 1.5,
    color: "Dark Green",
  },
  {
    origin: "Shizuoka",
    cultivation: "Conventional",
    category: "Premium",
    tea_type: "Matcha",
    name: "Shizuoka Matcha P-1",
    p2025: null,
    p2026: null,
    notes: "2026 harvest price available from early August",
    raw_details: "Kosher(KF) | Leaf Type: First + Second Flush",
    tasting_color: 3,
    tasting_umami: 3.5,
    tasting_astringency: 2.5,
    color: "Green",
  },
  {
    origin: "Shizuoka",
    cultivation: "Conventional",
    category: "Premium",
    tea_type: "Matcha",
    name: "Shizuoka Matcha P-2",
    p2025: "7,200",
    p2026: null,
    notes: "2025 HARVEST",
    raw_details:
      "Kosher(KF) | Leaf Type: First + Second Flush | Packaging: 1kg Net Weight, 10 Units/Carton",
    description:
      "A beautiful conventional premium grade providing solid color and vibrant aroma. Perfectly balanced for high-end boutique blending or specialized food service operations.",
    tasting_color: 2.5,
    tasting_umami: 2,
    tasting_astringency: 4,
    color: "Green",
  },
  {
    origin: "Shizuoka",
    cultivation: "Conventional",
    category: "Culinary",
    tea_type: "Matcha",
    name: "Shizuoka Matcha B",
    p2025: "6,960",
    p2026: null,
    notes: null,
    raw_details: "Kosher(KF) | Leaf Type: 1st + 2nd + Autumn Flush",
    description:
      "Standard industrial-strength baking culinary matcha. Reliable, sharp color preservation with structural bitterness that complements sugars and dairy beautifully.",
    tasting_color: 2,
    tasting_umami: 2.5,
    tasting_astringency: 3,
    color: "Vibrant Green",
  },
  {
    origin: "Shizuoka",
    cultivation: "Organic",
    category: "Hojicha",
    tea_type: "Hojicha",
    name: "Organic Hojicha",
    p2025: null,
    p2026: "10,800",
    notes: "2026 harvest",
    raw_details: "USDA Organic | JAS Organic | Kosher(KF) | Roasting Process: Deep Roasted",
  },

  {
    origin: "",
    cultivation: "Organic",
    category: "Tea Leaves",
    tea_type: "Kukicha",
    name: "Organic Kukicha",
    weight: "300g",
    p2025: null,
    p2026: "3,240",
    notes: "2026 harvest",
  },
  {
    origin: "",
    cultivation: "Organic",
    category: "Tea Leaves",
    tea_type: "Matcha",
    name: "Organic Genmaicha with Matcha",
    weight: "300g",
    p2025: null,
    p2026: "2,880",
    notes: "2026 harvest",
  },
  {
    origin: "",
    cultivation: "Organic",
    category: "Tea Leaves",
    tea_type: "Black Tea",
    name: "Organic Japanese Black Tea",
    weight: "300g",
    p2025: null,
    p2026: "3,000",
    notes: "2026 harvest",
  },
  {
    origin: "",
    cultivation: "Organic",
    category: "Tea Leaves",
    tea_type: "Hojicha",
    name: "Organic Kakegawa Hojicha Powder",
    p2025: null,
    p2026: null,
    notes: "2026 harvest price available from mid-July",
  },
  {
    origin: "",
    cultivation: "Conventional",
    category: "Tea Leaves",
    tea_type: "Sencha",
    name: "Asamiya Sencha (Asatsuyu)",
    weight: "300g",
    p2025: null,
    p2026: "4,800",
    notes: "2026 harvest, New Product Light-Steamed Green Tea / Pesticide-Free Cultivation",
  },
  {
    origin: "Shizuoka",
    cultivation: "Conventional",
    category: "Tea Leaves",
    tea_type: "Sencha",
    name: "Shizuoka Sencha (Saemidori)",
    weight: "300g",
    p2025: null,
    p2026: "4,200",
    notes: "2026 harvest, New Product Deep-Steamed Green Tea",
  },
  {
    origin: "",
    cultivation: "Conventional",
    category: "Tea Leaves",
    tea_type: "Kabusecha",
    name: "Tsuchiyama Kabusecha (Okumidori)",
    weight: "300g",
    p2025: null,
    p2026: "6,000",
    notes:
      "2026 harvest, New Product Light-Steamed Green Tea / Compliant with US and Taiwan Standards",
  },
  {
    origin: "Shizuoka",
    cultivation: "Conventional",
    category: "Tea Leaves",
    tea_type: "Kabusecha",
    name: "Yame Kabusecha (Tsuyuhikari)",
    weight: "300g",
    p2025: null,
    p2026: "3,600",
    notes: "2026 harvest, New Product Medium-Steamed Green Tea / Compliant with US Standards",
  },
  {
    origin: "Shizuoka",
    cultivation: "Conventional",
    category: "Tea Leaves",
    tea_type: "Gyokuro",
    name: "Uji Gyokuro (Komakage)",
    weight: "300g",
    p2025: null,
    p2026: "6,000",
    notes: "2026 harvest, New Product Medium-Steamed Green Tea",
  },
  {
    origin: "",
    cultivation: "Organic",
    category: "Tea Leaves",
    tea_type: "Hojicha",
    name: "Organic Hojicha (Tea Leaves)",
    weight: "300g",
    p2025: null,
    p2026: "1,080",
    notes: "2026 harvest, New Product Made Exclusively from First Harvest Japanese Tea Leaves",
  },
  {
    origin: "",
    cultivation: "Organic",
    category: "Tea Leaves",
    tea_type: "Sencha",
    name: "Organic Lemon Sencha",
    weight: "300g",
    p2025: null,
    p2026: "3,000",
    notes:
      "2026 harvest, New Product Shizuoka Second Harvest Green Tea with Lemon Myrtle and Lemon Peel",
  },

  {
    origin: "Uji",
    cultivation: "Conventional",
    category: "Ceremonial",
    tea_type: "Matcha",
    name: "Uji Matcha C",
    p2025: null,
    p2026: "36,000",
    notes: null,
    raw_details: "Packaging: 1kg Net Weight, 10 Units/Carton | Leaf Type: First Flush Only",
    description:
      "Authentic Uji Ceremonial Matcha representing the pinnacle of traditional Kyoto tea cultivation. Exceptionally smooth body, profound depth of sweet umami sweetness, and zero harshness.",
    tasting_color: 5,
    tasting_umami: 5,
    tasting_astringency: 1,
  },
  {
    origin: "Uji",
    cultivation: "Conventional",
    category: "Premium",
    tea_type: "Matcha",
    name: "Uji Matcha B",
    p2025: "9,600",
    p2026: null,
    notes: null,
    raw_details: "Kosher(KF) | Leaf Type: First + Autumn Flush",
    description:
      "Authentic Uji culinary matcha presenting excellent sharp structural profiles, perfectly matching high-heat baking and complex confectionery recipe requirements.",
    tasting_color: 3,
    tasting_umami: 3,
    tasting_astringency: 4,
    color: "Vibrant Green",
  },

  {
    origin: "Yame and Kagoshima",
    cultivation: "Conventional",
    category: "Premium",
    tea_type: "Matcha",
    name: "MATCHA POWDER MS05",
    p2025: null,
    p2026: "21,600",
    notes: "2026 harvest",
    raw_details: "Halal Certified | Leaf Type: Kyushu First Flush (Ichiban-cha)",
    description:
      "Made exclusively from elite first-flush tea leaves. Offers an excellent, pristine balance of creamy umami and strong top-note aroma, cutting beautifully through milk bases.",
    color: "",
  },
  {
    origin: "Yame and Kagoshima",
    cultivation: "Conventional",
    category: "Premium",
    tea_type: "Matcha",
    name: "MATCHA POWDER MS05-NT",
    p2025: null,
    p2026: "23,400",
    notes: "2026 harvest",
    raw_details: "Halal Certified | Leaf Type: First Flush Only",
    description:
      "Characterized by a deeply roasted, robust and intense flavor profile. Specially curated to provide an unforgettable punchy taste ideal for commercial premium beverage formulations.",
    color: "",
  },
  {
    origin: "Kagoshima",
    cultivation: "Organic",
    category: "Ceremonial",
    tea_type: "Matcha",
    name: "ORGANIC MATCHA POWDER MB07",
    p2025: null,
    p2026: "33,600",
    notes: null,
    raw_details: "JAS OCO, Halal Certified | Leaf Type: First Flush Only",
    description:
      "A supreme organic ceremonial matcha crafted solely from rare, first-flush organic Tencha. Delivers exquisite sweetness, rich body, and a smooth, dynamic profile.",
    color: "",
  },
  {
    origin: "Yame",
    cultivation: "Conventional",
    category: "Ceremonial",
    tea_type: "Matcha",
    name: "MATCHA POWDER MS07",
    p2025: null,
    p2026: "27,600",
    notes: null,
    raw_details:
      "Halal Certified | Packaging: 1kg Net Weight, 20 Units/Carton | Leaf Type: First Flush Only",
    description:
      "A rare, top-tier premium selection standing out for its intensely rich aroma and deep jade color. Perfectly balanced and ideally suited for traditional Usucha (thin tea) preparation.",
    color: "",
  },
  {
    origin: "Kyushu",
    cultivation: "Conventional",
    category: "Hojicha",
    tea_type: "Hojicha",
    name: "Hojicha Roasted Green Tea HS03",
    p2025: null,
    p2026: "6,000",
    notes: "2026 harvest",
    raw_details: "Halal Certified | Leaf Type: Roasted Blend",
    description:
      "Highly acclaimed for its advanced, precise roasting technique. Maximizes the sweet, smoky, and richly savory roasted aroma profile with negligible bitterness. Optimized for dynamic flavor depth in Lattes and structural Confectionery items.",
    tasting_color: null,
    tasting_umami: null,
    tasting_astringency: null,
  },
  {
    origin: "Yame",
    cultivation: "Conventional",
    category: "Culinary",
    tea_type: "Matcha",
    name: "Matcha Paste",
    p2025: null,
    p2026: "5,400",
    notes: "2026 harvest",
    raw_details: "Shelf Life: 365 days from unopened condition | Anti-Discoloration Formula",
    description:
      "Specially engineered formulation designed to be highly resistant to the degrading effects of intense heat, UV light, and natural food acids, making it less likely to discolor over time. Ideal for commercial bakeries, ice cream manufacturing, and long-shelf-life culinary retail goods.",
    tasting_color: null,
    tasting_umami: null,
    tasting_astringency: null,
  },

  // {
  //   category: "Sample Kits",
  //   tea_type: "Matcha",
  //   name: "Organic Matcha Selection + Hojicha Powder",
  //   p2025: null,
  //   p2026: "3,333",
  //   notes: null,
  //   raw_details:
  //     "recommended_for: Organic brands, premium cafes, health-conscious markets | includes: 1. Organic Matcha C-1 10g x 1, 2. Organic Matcha C-2 10g x 1, 3. Organic Matcha P-1 10g x 1, 4. Organic Matcha P-2 10g x 1, 5. Organic Matcha B 10g x 1, 6. Organic Hojicha Powder 10g x 1",
  //   description: null,
  //   image_override: "/assets/images/sample-kits/organic-matcha-hojicha-placeholder.svg",
  // },
  // {
  //   category: "Sample Kits",
  //   tea_type: "Matcha",
  //   name: "Japanese Matcha Selection + Hojicha Powder",
  //   p2025: null,
  //   p2026: "3,333",
  //   notes: null,
  //   raw_details:
  //     "recommended_for: Cafes, matcha latte, beverage development, food service | includes: 1. Shizuoka Matcha C 10g x 1, 2. Shizuoka Matcha S 10g x 1, 3. Shizuoka Matcha P-1 10g x 1, 4. Shizuoka Matcha P-2 10g x 1, 5. Shizuoka Matcha B 10g x 1, 6. Uji Matcha B 10g x 1, 7. Organic Hojicha Powder 10g x 1",
  //   description: null,
  //   image_override: "/assets/images/sample-kits/japanese-matcha-hojicha-placeholder.svg",
  // },
  // {
  //   category: "Sample Kits",
  //   tea_type: "Matcha",
  //   name: "Complete Matcha Collection",
  //   p2025: null,
  //   p2026: "7,500",
  //   notes: null,
  //   raw_details:
  //     "recommended_for: Importers, distributors, and customers comparing all matcha grades | includes: 1. Organic Matcha C-1 10g x 1, 2. Organic Matcha C-2 10g x 1, 3. Organic Matcha P-1 10g x 1, 4. Organic Matcha P-2 10g x 1, 5. Organic Matcha B 10g x 1, 6. Shizuoka Matcha C 10g x 1, 7. Shizuoka Matcha S 10g x 1, 8. Shizuoka Matcha P-1 10g x 1, 9. Shizuoka Matcha P-2 10g x 1, 10. Shizuoka Matcha B 10g x 1, 11. Uji Matcha B 10g x 1, 12. Organic Hojicha Powder 10g x 1",
  //   description: null,
  //   image_override: "/assets/images/sample-kits/complete-matcha-collection-placeholder.svg",
  // },
  // {
  //   category: "Sample Kits",
  //   name: "Japanese Loose Leaf Tea Collection",
  //   p2025: null,
  //   p2026: "6,666",
  //   notes: null,
  //   raw_details:
  //     "recommended_for: Specialty tea shops, premium cafe, premium tea brands, Importers and distributors. | includes: 1. Deep Steamed Sencha Saemidori 10g x 1, 2. Organic Genmaicha with Matcha Powder 10g x 1, 3. Organic Hojicha 10g x 1, 4. Organic Kukicha 10g x 1, 5. Organic Wakocha 10g x 1, 6. Organic Lemon Sencha 10g x 1, 7. Uji Gyokuro Komakage 10g x 1, 8. Asamiya Sencha Asatsuyu 10g x 1, 9. Tsuchiyama Kabusecha Okumidori 10g x 1, 10. Yame Kabusecha Tsuyuhikari 10g x 1",
  //   description: null,
  //   image_override: "/assets/images/sample-kits/loose-leaf-tea-collection-placeholder.svg",
  // },
  // {
  //   type: "Handcrafted",
  //   category: "Teaware",
  //   name: "Matcha Bowl Hagimurasaki Hagi Ware",
  //   p2025: null,
  //   p2026: null,
  //   notes: null,
  //   raw_details:
  //     "Material: Ceramic | images: /assets/images/teaware/A19-1-2.jpg,/assets/images/teaware/A19-1-3.png",
  //   description:
  //     "Hagi Yaki is a living vessel—gentle care allows its beauty to deepen and evolve over time.",
  //   tasting_color: null,
  //   tasting_umami: null,
  //   tasting_astringency: null,
  //   image_override: "/assets/images/teaware/A19-1-1.webp",
  // },
  // {
  //   type: "Handcrafted",
  //   category: "Teaware",
  //   name: "Matcha Bowl Himetsuchi Hagi Ware",
  //   p2025: null,
  //   p2026: null,
  //   notes: null,
  //   raw_details:
  //     "Material: Ceramic | images: /assets/images/teaware/A18-1-2.jpg,/assets/images/teaware/A18-1-3.jpg",
  //   description:
  //     "Hagi Yaki is a living vessel—gentle care allows its beauty to deepen and evolve over time.",
  //   tasting_color: null,
  //   tasting_umami: null,
  //   tasting_astringency: null,
  //   image_override: "/assets/images/teaware/A18-1-1.jpg",
  // },
  // {
  //   category: "Gift Selection",
  //   tea_type: "Matcha",
  //   name: "The Matcha Master Gift Set",
  //   p2025: null,
  //   p2026: "12,500",
  //   notes: "Custom gift selection is possible upon request.",
  //   raw_details: "includes: Organic Matcha P-1 (30g), Organic Matcha C-2 (30g)",
  //   description:
  //     "An elegant, comprehensive matcha tasting set presented in a beautiful wooden gift box. Features our finest premium and ceremonial grade matchas for a luxurious tasting experience.",
  //   tasting_color: null,
  //   tasting_umami: null,
  //   tasting_astringency: null,
  //   image_override: "/assets/images/gift-selection/matcha-master-gift-set-placeholder.svg",
  // },
  // {
  //   category: "Gift Selection",
  //   tea_type: "Sencha & Hojicha",
  //   name: "Everyday Japanese Tea Gift Box",
  //   p2025: null,
  //   p2026: "8,900",
  //   notes: "Custom gift selection is possible upon request.",
  //   raw_details:
  //     "includes: Organic Asamushi Sencha Yabukita (100g), Organic Hojicha (100g), Organic Gyokuro (100g)",
  //   description:
  //     "The perfect introduction to traditional Japanese loose leaf tea. This luxurious gift box includes three of our premium organic teas, perfectly balancing umami, sweetness, and deep roasted flavors.",
  //   tasting_color: null,
  //   tasting_umami: null,
  //   tasting_astringency: null,
  //   image_override: "/assets/images/gift-selection/everyday-tea-gift-box-placeholder.svg",
  // },
  // {
  //   type: "Handcrafted",
  //   category: "Teaware",
  //   name: "100-Prong Bamboo Whisk (Chasen)",
  //   p2025: null,
  //   p2026: "1,800",
  //   notes: null,
  //   raw_details: "Material: Bamboo",
  //   description:
  //     "A traditional Japanese bamboo whisk, masterfully crafted with 100 delicate prongs to create the perfect smooth, rich foam for your matcha.",
  //   tasting_color: null,
  //   tasting_umami: null,
  //   tasting_astringency: null,
  //   image_override: "/assets/images/teaware/whisk.png",
  // },
  // {
  //   type: "Handcrafted",
  //   category: "Teaware",
  //   name: "80-Prong Bamboo Whisk (Chasen)",
  //   p2025: null,
  //   p2026: "1,650",
  //   notes: null,
  //   raw_details: "Material: Bamboo",
  //   description:
  //     "A traditional Japanese bamboo whisk, masterfully crafted with 80 sturdy prongs. Ideal for everyday matcha preparation, offering a slightly thicker prong structure than the 100-prong variety.",
  //   tasting_color: null,
  //   tasting_umami: null,
  //   tasting_astringency: null,
  //   image_override: "/assets/images/teaware/whisk-80.png",
  // },
];

const productImages: Record<string, string> = {
  "organic-matcha-p-1": "/assets/images/products/organic-matcha-p-1-transparent.png",
  "organic-matcha-p-2": "/assets/images/products/organic-matcha-p-2-transparent.png",
  "shizuoka-matcha-p-1": "/assets/images/products/shizuoka-matcha-p-1-transparent.png",
  "shizuoka-matcha-p-2": "/assets/images/products/shizuoka-matcha-p-2-transparent.png",
  "organic-matcha-c-1": "/assets/images/products/organic-matcha-c-1.jpg",
  "organic-matcha-c-2": "/assets/images/products/organic-matcha-c-2-transparent.png",
  "shizuoka-matcha-c": "/assets/images/products/shizuoka-matcha-c-transparent.png",
  "shizuoka-matcha-s": "/assets/images/products/shizuoka-matcha-s-transparent.png",
  "uji-matcha-b": "/assets/images/products/uji-matcha-b-transparent.png",
  "organic-matcha-b": "/assets/images/products/organic-matcha-b.jpg",
  "shizuoka-matcha-b": "/assets/images/products/shizuoka-matcha-b-transparent.png",
  "matcha-powder-ms05": "/assets/images/products/matcha-powder-ms05-transparent.png",
  "matcha-powder-ms05-nt": "/assets/images/products/matcha-powder-ms05-nt-transparent.png",
  "matcha-powder-ms07": "/assets/images/products/matcha-powder-ms07-transparent.png",
  "organic-matcha-powder-mb07":
    "/assets/images/products/organic-matcha-powder-mb07-transparent.png",
  "hojicha-hs03": "/assets/images/products/hojicha-hs03-transparent.png",
  "hojicha-roasted-green-tea-hs03": "/assets/images/products/hojicha-hs03-transparent.png",
  "matcha-paste": "/assets/images/products/matcha-paste-transparent.png",
  "organic-hojicha": "/assets/images/products/organic_hojicha_powder-transparent.png",
  "organic-asamushi-sencha-yabukita": "/assets/images/packages/CHawa_Asamushi_Sencha_Yabukita.png",
  "organic-kukicha": "/assets/images/packages/CHawa_Organic_Kukicha.png",
  "organic-genmaicha-with-matcha": "/assets/images/packages/CHawa_Genmaicha_with_Matcha.png",
  "organic-japanese-black-tea": "/assets/images/packages/CHawa_Japanese_Black_Tea.png",
  "organic-kakegawa-hojicha-powder": "/assets/images/packages/CHawa_Kakegawa_Hojicha_Powder.png",
  "asamiya-sencha-asatsuyu": "/assets/images/packages/CHawa_Asamiya_Sencha_Asatsuyu.png",
  "shizuoka-sencha-saemidori": "/assets/images/packages/CHawa_Shizuoka_Sencha_Saemidori.png",
  "tsuchiyama-kabusecha-okumidori":
    "/assets/images/packages/CHawa_Tsuchiyama_Kabusecha_Okumidori.png",
  "yame-kabusecha-tsuyuhikari": "/assets/images/packages/CHawa_Yame_Kabusecha_Tsuyuhikari.png",
  "uji-gyokuro-komakage": "/assets/images/packages/CHawa_Uji_Gyokuro_Komakage.png",
  "organic-lemon-sencha": "/assets/images/products/organic-lemon-sencha.png",
  "uji-matcha-c": "/assets/images/products/shizuoka-matcha-c-transparent.png",
};

const productAdditionalImages: Record<string, string> = {
  "organic-matcha-p-1": "/assets/images/packages/Organic_Matcha_P1.png",
  "organic-matcha-p-2": "/assets/images/packages/Organic_Matcha_P2.png",
  "shizuoka-matcha-p-1": "/assets/images/packages/Shizuoka_Matcha_P1.png",
  "shizuoka-matcha-p-2": "/assets/images/packages/Shizuoka_Matcha_P2.png",
  "organic-matcha-c-1": "/assets/images/packages/Organic_Matcha_C1.png",
  "organic-matcha-c-2": "/assets/images/packages/Organic_Matcha_C2.png",
  "uji-matcha-b": "/assets/images/packages/Uji_Matcha_B.png",

  "matcha-powder-ms05": "/assets/images/packages/MS05.png",
  "matcha-powder-ms05-nt": "/assets/images/packages/MS05_NT.png",
  "organic-matcha-powder-mb07": "/assets/images/packages/MB07.png",
  "hojicha-roasted-green-tea-hs03": "/assets/images/packages/CHawa_HS03.png",
  "matcha-paste": "/assets/images/packages/CHawa_Matcha_Paste.png",
};

function formatPrice(val: string | null) {
  if (!val) return null;
  const num = parseInt(val.replace(/[^0-9]/g, ""), 10);
  if (isNaN(num)) return null;
  return `¥${num.toLocaleString()}`;
}

export const productsSeed = rawProducts.map((p, index) => {
  const handle = p.name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

  // Determine Product Category
  let catId = "cat-tea";
  let productType = "Tea";
  // if (p.category === "Sample Kits") {
  //   catId = "cat-kits";
  //   productType = "Sample Kits";
  // }
  // else if (p.category === "Teaware" || p.category === "Tea Ware") {
  //   catId = "cat-teaware";
  //   productType = "Tea Ware";
  // }
  // else if (p.category === "Gift Selection") {
  //   catId = "cat-gift";
  //   productType = "Gift Selection";
  // }
  const cat = categoriesSeed.find((c) => c.id === catId);

  let imageUrl = (p as any).image_override || null;
  if (!imageUrl && productImages[handle]) {
    imageUrl = productImages[handle];
  }
  if (!imageUrl) {
    if (p.category === "Premium") imageUrl = "/assets/images/categories/premium_icon.webp";
    else if (p.category === "Ceremonial") imageUrl = "/assets/images/ceremonial_matcha.png";
    else if (p.category === "Culinary") imageUrl = "/assets/images/culinary_matcha.png";
    else if (p.category === "Hojicha")
      imageUrl = "/assets/images/products/organic_hojicha_powder-transparent.png";
    else if (p.category === "Tea Leaves") {
      if (p.tea_type === "Sencha") imageUrl = "/assets/images/tea-types/sencha_icon.png";
      else if (p.tea_type === "Kukicha") imageUrl = "/assets/images/tea-types/kukicha_icon.png";
      else if (p.tea_type === "Gyokuro") imageUrl = "/assets/images/tea-types/gyokuro_icon.png";
      else if (p.tea_type === "Kabusecha") imageUrl = "/assets/images/tea-types/kabusecha_icon.png";
      else if (p.tea_type === "Black Tea")
        imageUrl = "/assets/images/tea-types/black_tea_icon_v2.png";
      else imageUrl = "/assets/images/loose_leaf_tea.png";
    }
    // else if (p.category === "Sample Kits")
    //   imageUrl = "/assets/images/categories/sample_kits_icon.png";
    else if (p.tea_type === "Matcha") imageUrl = "/assets/images/tea-types/matcha_icon.png";
  }

  // Deduce Origin from name or fallback
  const nameLower = p.name.toLowerCase();
  let deducedOrigin = (p as any).origin;
  if (nameLower.includes("shizuoka")) deducedOrigin = "Shizuoka";
  else if (nameLower.includes("yame and kagoshima") || (p as any).origin === "Yame and Kagoshima")
    deducedOrigin = "Yame and Kagoshima";
  else if (nameLower.includes("yame")) deducedOrigin = "Yame";
  else if (nameLower.includes("uji")) deducedOrigin = "Uji";
  else if (nameLower.includes("kagoshima")) deducedOrigin = "Kagoshima";
  else if (nameLower.includes("kyushu") || (p as any).raw_details?.toLowerCase().includes("kyushu"))
    deducedOrigin = "Kyushu";

  // Deduce Format
  let deducedFormat = "Powder"; // Default for Matcha/Hojicha powder
  if (p.category === "Tea Leaves") {
    deducedFormat = "Loose Leaf";
  } else if (nameLower.includes("paste")) {
    deducedFormat = "Paste";
  }

  // Deduce Grade
  let deducedGrade = "";
  if (p.category === "Ceremonial") deducedGrade = "Ceremonial";
  else if (p.category === "Premium") deducedGrade = "Premium";
  else if (p.category === "Culinary") deducedGrade = "Culinary";

  const rawSpecs: any = {
    product: productType,
    tea_type: p.tea_type,
    origin: deducedOrigin,
  };

  if (deducedFormat) rawSpecs.format = deducedFormat;
  if (deducedGrade) rawSpecs.grade = deducedGrade;
  if ((p as any).type) rawSpecs.type = (p as any).type;
  if ((p as any).cultivation) rawSpecs.cultivation = (p as any).cultivation;

  // Deduce Color based on tasting_color 1-5
  if (p.tasting_color != null) {
    rawSpecs.tasting_color = String(p.tasting_color);
    const cVal = p.tasting_color;
    let colorName = "Light Green";
    if (cVal > 4) colorName = "Vibrant Green";
    else if (cVal > 3) colorName = "Deep Green";
    else if (cVal > 2) colorName = "Dark Green";
    else if (cVal > 1) colorName = "Green";

    rawSpecs.color = colorName;
    rawSpecs["Color "] = colorName; // For display on product page
  } else if ((p as any).color) {
    rawSpecs.color = (p as any).color;
    rawSpecs["Color "] = (p as any).color;
  }

  if (p.tasting_umami != null) rawSpecs.tasting_umami = String(p.tasting_umami);
  if (p.tasting_astringency != null) rawSpecs.tasting_astringency = String(p.tasting_astringency);

  if ((p as any).raw_details) {
    const detailsStr = (p as any).raw_details as string;
    const parts = detailsStr.split("|").map((s) => s.trim());
    const certs: string[] = [];

    parts.forEach((part) => {
      const colonIndex = part.indexOf(":");
      if (colonIndex > 0) {
        const key = part.substring(0, colonIndex).trim();
        const val = part.substring(colonIndex + 1).trim();
        rawSpecs[key] = val;
      } else {
        const lower = part.toLowerCase();
        if (
          lower.includes("kosher") ||
          lower.includes("halal") ||
          lower.includes("jas") ||
          lower.includes("compliant") ||
          lower.includes("organic")
        ) {
          certs.push(part);
        } else {
          rawSpecs[part] = "Yes";
        }
      }
    });

    if (certs.length > 0) {
      rawSpecs.certifications = certs.join(", ");
    }
  }

  if (productAdditionalImages[handle]) {
    if (rawSpecs.images) {
      rawSpecs.images += "," + productAdditionalImages[handle];
    } else {
      rawSpecs.images = productAdditionalImages[handle];
    }
  }

  const weight = (p as any).weight || "1KG";

  const p25 = formatPrice(p.p2025);
  if (p25) rawSpecs["2025 Stock Price"] = `${p25} / ${weight} EXW Japan (excl. tax)`;

  const p26 = formatPrice(p.p2026);
  if (p26) rawSpecs["2026 Stock Price"] = `${p26} / ${weight} EXW Japan (excl. tax)`;

  if (p.notes) rawSpecs["Availability Notes"] = p.notes;

  const specs: any = {};
  Object.keys(rawSpecs)
    .sort((a, b) => a.localeCompare(b))
    .forEach((k) => {
      specs[k] = rawSpecs[k];
    });

  return {
    id: `prod-${index + 1}`,
    name: p.name.trim(),
    handle: handle,
    category_id: cat ? cat.id : "cat-unknown",
    active: true,
    description: (p as any).description || null,
    short_description: null,
    image_url: imageUrl,
    sort_order: index + 1,
    specs,
    created_at: new Date().toISOString(),
  };
});

export const productCategoriesSeed = productsSeed.map((p) => ({
  product_id: p.id,
  category_id: p.category_id,
  created_at: new Date().toISOString(),
}));
